module.exports = __webpack_public_path__ + "static/professional-recommendations-67abd9ab8ef088d4c4fc55b4b8a7b405.jpg";